/** intl-ignore */
export default {
  "menu.9001": "User Management",
  "menu.9003": "Role List",
  "menu.9004": "Status Code",
  "menu.9005": "Firmware Version",
  "menu.9008": "Enterprise Management",
  "menu.9013": "Menu Management",
  "menu.215192": "Equipment Management",
  "menu.217301": "Report Management",
  "menu.264427": "System Management",
  "menu.421903": "Maintenance Management",
  "menu.435731": "Pile Consolidation Equipment",
  "menu.470879": "Communication topology",
  "menu.518842": "Control topology",
  "menu.598633": "Log Service",
  "menu.731278": "Detection information",
  "menu.731748": "Platform Configuration",
  "menu.765783": "Set screensaver",
  "menu.781441": "Charger Equipment Log",
  "menu.803041": "Charger Operation Log",
  "menu.900401": "Status code configuration",
  "menu.900501": "New firmware",
  "menu.900502": "Edit firmware",
  "menu.900506": "Delete firmware version",
  "menu.0101": "Charging Station",
  "menu.010101": "New Station",
  "menu.010102": "Editing yard",
  "menu.010103": "Site topology diagram",
  "menu.0102": "Charging Connector",
  "menu.010201": "Basic information",
  "menu.0103": "Warehouse Charger",
  "menu.010301": "Warehouse Charger Details",
  "menu.0104": "Distribution Cabinet",
  "menu.0105": "Modules",
  "menu.010501": "Historical device",
  "menu.010502": "Module information",
  "menu.010503": "Module data",
  "menu.0106": "High Voltage Equipment",
  "menu.010601": "New high-voltage equipment",
  "menu.010602": "Edit high-voltage equipment",
  "menu.010603": "High voltage equipment details",
  "menu.0107": "Charger",
  "menu.010701": "New Charger",
  "menu.010702": "Edit Charger",
  "menu.010703": "Charger Details",
  "menu.010711": "Box Charger Detail Data",
  "menu.0108": "Warehouse Charging Connector",
  "menu.010801": "Warehouse charging connector details",
  "menu.0109": "Energy Equipment",
  "menu.010901": "Energy equipment details",
  "menu.010902": "Configuration",
  "menu.0110": "FTP Management",
  "menu.011001": "Add FTP Mapping Mngm",
  "menu.0111": "Material BOM",
  "menu.0303": "BI Report",
  "menu.0401": "Charger Fault Report",
  "menu.0402": "Platform Monitor Event List",
  "menu.040201": "Rule details",
  "menu.040202": "Operational data",
  "menu.040411": "Device Topology",
  "menu.0405": "Energy Equipment Fault Report",
  "menu.0501": "Charging Order",
  "menu.0502": "Charger Connection Logs",
  "menu.0503": "Task Management",
  "menu.050301": "Configuration modification",
  "menu.050302": "Firmware upgrade",
  "menu.050303": "Get the latest configuration",
  "menu.050304": "Modified state",
  "menu.050305": "Batch add devices",
  "menu.0506": "Maintenance Start Stop Orders",
  "menu.0508": "Equipment Operation Log",
  "menu.0509": "Pile End Log Report",
  "menu.050901": "New pile end log",
  "menu.0510": "Charger Communication Log",
  "menu.064717": "Abnormity Management",
  "menu.077489": "Station Management",
  "menu.20210706password": "Change password",
  "menu.20210712createcompany": "New company",
  "menu.chargeCourse": "Charge data",
  "menu.newFirmwaredetail": "Version details",
  "menu.op_platform_0802": "Energy Communication Log",
  "menu.temperatureMonitoring": "Temperature monitoring",
  "menu.269579": "Charging Connector fault details",
  "menu.010202": "Charging Connector Details",
  "menu.523682": "Charging Connector fault details",
  "menu.591260": "Dispatch Rules",
  "menu.356616": "Add Dispatch Rules",
  "menu.368060": "Edit Dispatch Rules",
  "menu.375990": "View Dispatch Rules",
  "menu.766142": "Alarm Rules",
  "menu.965626": "Add Alarm Rules",
  "menu.970782": "Edit Alarm Rules",
  "menu.976120": "View Alarm Rules",
  "menu.120495": "Abnormal Monitor",
  "menu.610780": "Details of abnormal monitor",
  "menu.550256": "Station Monitor",
  "menu.433523": "Operational data",
  "menu.371467": "Operating Log",
  "menu.467650": "Home",
  "menu.539536": "EUC Communication topology",
  "menu.396063": "Off-grid topology",
  "menu.836220": "Version Server",
  "menu.EP_593464": "Firmware Detail",
  "menu.EP_698248": "Add Firmware",
  "menu.EP_714591": "Edit Firmware",
  "menu.042899": "Discharging Order",
  "menu.103201": "System Notification",
  "menu.130986": "Notification Details",
  "menu.053794": "Add Notification",
  "menu.092475": "Edit Notification",
  "menu.876953": "eSIM Card Management",
  "menu.OMC_EP_685512": "eSIM Card Detail",
  "menu.193529": "Message Center",
  "menu.OMC_EP_731866": "Discharging Data",
  "menu.933322": "Household Device",
  "menu.EP_141226": "Household Device Detail",
  "menu.EP_228385": "Household Device Configuration",
  "menu.876198": "Household Device Log",
  "menu.051204": "Household Operate Log",
  "menu.767469": "Device Security Auth",
  "menu.627951": "Lock failure statistics",
  "menu.968604": "Equipment Anomaly Statistics",
  "menu.96860401": "Lock failure statistics",
  "menu.431117": "Sub Gun Order",
  "menu.368708": "Charge Date",
  "menu.387009": "Module data",
  "menu.chargerTopology": "充电桩拓扑",
  "menu.085990": "AI Log Diagnostics",
  "menu.aiDiagnosticTaskAdd": "New AI Diagnostic Task",
  "menu.aiDiagnosticTaskDetail": "AI Diagnosis Details",
  "menu.808649": "Charger Topology",
  "menu.278064": "Import Warranty",
  "menu.943846": "Statistic Cockpit",
  "menu.OMC_EP_834620": "Business Energy Device",
  "menu.OMC_EP_834621": "Business Energy Device Detail",
  "menu.OMC_EP_834622": "Business Energy Event",
};
